
export const galleryImages = [
  {
    id: 1,
    title: 'Handcrafted with Love',
    description: 'Each bowl is carefully shaped and finished by hand',
    url: 'https://public.readdy.ai/ai/img_res/8b5f9e2fedbeb0a71d7d82c66000669f.jpg'
  },
  {
    id: 2,
    title: 'Natural Wood Grain',
    description: 'Celebrating the unique patterns of northeast Ohio wood',
    url: 'https://readdy.ai/api/search-image?query=Beautiful%20wooden%20bowl%20showing%20detailed%20natural%20wood%20grain%20patterns%20and%20texture%2C%20warm%20brown%20tones%2C%20clean%20simple%20background%2C%20professional%20product%20photography%2C%20studio%20lighting&width=800&height=800&seq=gallery-grain-001&orientation=squarish'
  },
  {
    id: 3,
    title: 'Workshop Craftsmanship',
    description: 'Where tradition meets artistry',
    url: 'https://readdy.ai/api/search-image?query=Artisan%20woodworking%20workshop%20with%20wooden%20bowls%20being%20crafted%2C%20wood%20lathe%20and%20tools%2C%20warm%20workshop%20lighting%2C%20wood%20shavings%2C%20clean%20simple%20background%2C%20documentary%20style%20photography&width=800&height=800&seq=gallery-workshop-001&orientation=squarish'
  },
  {
    id: 4,
    title: 'Nested Bowl Set',
    description: 'Perfectly sized bowls that nest together beautifully',
    url: 'https://readdy.ai/api/search-image?query=Set%20of%20nested%20handcrafted%20wooden%20bowls%20in%20different%20sizes%2C%20natural%20wood%20tones%2C%20arranged%20artistically%2C%20clean%20simple%20background%2C%20professional%20product%20photography%2C%20studio%20lighting&width=800&height=800&seq=gallery-nested-001&orientation=squarish'
  },
  {
    id: 5,
    title: 'Rich Walnut Tones',
    description: 'Deep, luxurious colors from local walnut trees',
    url: 'https://readdy.ai/api/search-image?query=Dark%20walnut%20wooden%20bowl%20with%20rich%20chocolate%20brown%20color%20and%20beautiful%20grain%2C%20polished%20finish%2C%20clean%20simple%20background%2C%20professional%20product%20photography%2C%20dramatic%20lighting&width=800&height=800&seq=gallery-walnut-001&orientation=squarish'
  },
  {
    id: 6,
    title: 'Artisan Details',
    description: 'Every curve and contour thoughtfully designed',
    url: 'https://readdy.ai/api/search-image?query=Close-up%20detail%20of%20handcrafted%20wooden%20bowl%20rim%20and%20curves%2C%20showing%20smooth%20finish%20and%20craftsmanship%2C%20natural%20wood%20texture%2C%20clean%20simple%20background%2C%20professional%20photography&width=800&height=800&seq=gallery-detail-001&orientation=squarish'
  },
  {
    id: 7,
    title: 'Table Setting',
    description: 'Perfect for everyday dining and special occasions',
    url: 'https://readdy.ai/api/search-image?query=Wooden%20bowl%20on%20elegant%20dining%20table%20setting%2C%20natural%20table%20decor%2C%20warm%20ambient%20lighting%2C%20clean%20simple%20background%2C%20lifestyle%20photography%2C%20inviting%20atmosphere&width=800&height=800&seq=gallery-table-001&orientation=squarish'
  },
  {
    id: 8,
    title: 'Sustainable Sourcing',
    description: 'Locally harvested wood from northeast Ohio forests',
    url: 'https://readdy.ai/api/search-image?query=Stack%20of%20raw%20wood%20logs%20and%20lumber%20in%20workshop%2C%20natural%20wood%20texture%2C%20sustainable%20forestry%2C%20clean%20simple%20background%2C%20documentary%20style%2C%20warm%20natural%20lighting&width=800&height=800&seq=gallery-wood-001&orientation=squarish'
  },
  {
    id: 9,
    title: 'Finished Masterpiece',
    description: 'A completed bowl ready for its new home',
    url: 'https://readdy.ai/api/search-image?query=Beautiful%20finished%20handcrafted%20wooden%20bowl%20with%20perfect%20polish%20and%20shine%2C%20natural%20wood%20grain%20visible%2C%20clean%20simple%20background%2C%20professional%20product%20photography%2C%20studio%20lighting&width=800&height=800&seq=gallery-finished-001&orientation=squarish'
  }
];
